// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  warId: __t.u64().primaryKey().name("war_id"),
  attackerKind: __t.string().name("attacker_kind"),
  attackerId: __t.u64().name("attacker_id"),
  attackerName: __t.string().name("attacker_name"),
  defenderKind: __t.string().name("defender_kind"),
  defenderId: __t.u64().name("defender_id"),
  defenderName: __t.string().name("defender_name"),
  declaredBy: __t.identity().name("declared_by"),
  state: __t.string(),
  stakeA: __t.i64().name("stake_a"),
  stakeB: __t.i64().name("stake_b"),
  scoreA: __t.u32().name("score_a"),
  scoreB: __t.u32().name("score_b"),
  result: __t.string(),
  peaceA: __t.bool().name("peace_a"),
  peaceB: __t.bool().name("peace_b"),
  lastBannerA: __t.timestamp().name("last_banner_a"),
  lastBannerB: __t.timestamp().name("last_banner_b"),
  declaredAt: __t.timestamp().name("declared_at"),
  activeAt: __t.timestamp().name("active_at"),
  endsAt: __t.timestamp().name("ends_at"),
  endedAt: __t.timestamp().name("ended_at"),
});
